import React, { useState } from "react";
import { Alert } from "@deere/fuel-react";

const Banner = (props) => {
  const [isVisible, setIsVisible] = useState(true);
  const handleClose = () => {
    if (isVisible === true) {
      setIsVisible(false);
    }
  };

  return (
    <div>
      {isVisible && (
        <Alert
          hasCloseButton
          onClose={handleClose}
          title=""
          variant="info"
          style={{ marginTop: "24px", marginLeft: "16px", marginRight: "16px" }}
        >
          {props.bannerMsg}
        </Alert>
      )}
    </div>
  );

};

export default Banner;